export enum RELEASE_TYPE {
  FEATURE = 'FEATURE',
  RELEASE_NOTES = 'RELEASE_NOTES',
}

export enum PRODUCT_TAG {
  ONLINE_ORDERING = 'ONLINE_ORDERING',
  BACKOFFICE = 'BACKOFFICE',
  FINANCE = 'FINANCE',
  API = 'API',
  EXPRESS = 'EXPRESS',
  TSR = 'TSR',
  QSR = 'QSR',
  KDS = 'KDS',
  QR = 'QR',
  INTEGRATIONS = 'INTEGRATIONS',
  HANDHELD = 'HANDHELD',
}
